import React, {Component} from 'react';
import {connect} from 'react-redux';

class Heading extends Component {
    render() {
        const {score, bestScore, addition, show} = this.props;
        return (
            <div>
            <div className="heading">
                <div className="scores-container">
                    <div className="score-container">
                        {score}
                        {show
                            ? <div className="score-addition">{`+${addition}`}</div>
                            : ''}

                    </div>
                    &nbsp;
                    <div className="best-container">{bestScore}</div>
                </div>
            </div>
            </div>
        )
    }
}

export default connect(({score, bestScore, addition}) => {
    return {score, bestScore, addition: addition.score, show: addition.show};
}, {})(Heading);


// WEBPACK FOOTER //
// ./src/components/web/heading/index.jsx